var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('layout',[_c('keep-alive',{attrs:{"include":"Dashboard,QuickSignout"}},[_c('router-view')],1)],1),_c('StagingPopup'),_c('update-popup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }